// Cua d'events de fitxatge pendents de sincronitzar (CURRENT_TASK.md §10,
// §12): IndexedDB, mai localStorage com a cua principal. Cada event pendent
// conserva tot el necessari per reenviar-lo a ControlHorariFitxar.php quan
// torni la connexió, sense dependre de res més que aquest registre.
//
// Forma d'un "pendent":
// {
//   uuidEvent, tipusEvent, dataHoraEvent, uuidTerminal, nomTerminal,
//   idTipusPausa, nomTipusPausa, estatGPS, latitud, longitud, precisioMetres,
//   estatLocal: "PENDENT" | "ERROR", ultimError, dataCreacioLocal,
// }

const DB_NAME = "ControlHorariDB";
const DB_VERSION = 1;
const STORE = "eventsPendents";

let dbPromise = null;

function chObrirDB() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB no disponible en aquest navegador."));
      return;
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: "uuidEvent" });
        store.createIndex("dataHoraEvent", "dataHoraEvent", { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

// Avisa la resta de la interfície (p. ex. el badge del ControlHorariLayout)
// que la cua ha canviat, sense necessitat de sondejar-la contínuament.
function chAvisarCanviPendents() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("ch-pendents-canvi"));
  }
}

export async function chGuardarPendent(pendent) {
  const db = await chObrirDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(pendent);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  chAvisarCanviPendents();
}

export async function chLlistarPendents() {
  const db = await chObrirDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => {
      const llista = req.result || [];
      llista.sort((a, b) => (a.dataHoraEvent < b.dataHoraEvent ? -1 : a.dataHoraEvent > b.dataHoraEvent ? 1 : 0));
      resolve(llista);
    };
    req.onerror = () => reject(req.error);
  });
}

export async function chEsborrarPendent(uuidEvent) {
  const db = await chObrirDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(uuidEvent);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  chAvisarCanviPendents();
}

export async function chMarcarErrorPendent(uuidEvent, missatge) {
  const db = await chObrirDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    const store = tx.objectStore(STORE);
    const getReq = store.get(uuidEvent);
    getReq.onsuccess = () => {
      const actual = getReq.result;
      if (actual) {
        actual.estatLocal = "ERROR";
        actual.ultimError = missatge;
        store.put(actual);
      }
    };
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
  chAvisarCanviPendents();
}

export async function chComptarPendents() {
  try {
    const llista = await chLlistarPendents();
    return llista.length;
  } catch {
    return 0;
  }
}
